<template>
  <section class="ticket-loader" aria-live="polite">
    <div class="ticket-loader__shell">
      <div class="ticket-loader__header">
        <span class="ticket-loader__eyebrow">Preparando accesos</span>
        <h3>Estamos preparando tu orden.</h3>
        <p>Generamos el archivo final y validamos los QR antes del envío.</p>
      </div>

      <div class="ticket-loader__stage">
        <div class="ticket-loader__steps">
          <article class="ticket-loader__step is-active">
            <strong>01</strong>
            <span>Generando PDF</span>
          </article>
          <article class="ticket-loader__step is-active">
            <strong>02</strong>
            <span>Preparando QR</span>
          </article>
          <article class="ticket-loader__step">
            <strong>03</strong>
            <span>Listo para envío</span>
          </article>
        </div>

        <div class="ticket-loader__visual">
          <div class="ticket-loader__ticket ticket-loader__ticket--back"></div>
          <div class="ticket-loader__ticket ticket-loader__ticket--front">
            <div class="ticket-loader__ticket-top">
              <span>FOMO</span>
              <small>QR PASS</small>
            </div>
            <div class="ticket-loader__ticket-copy">
              <strong>Acceso en preparación</strong>
              <p>Tu archivo se está armando con los datos finales de la orden.</p>
            </div>
            <div class="ticket-loader__qr-shell">
              <div class="ticket-loader__qr-grid">
                <span v-for="module in qrModules" :key="module.key" class="ticket-loader__qr-module" :style="{ left: `${module.x}px`, top: `${module.y}px` }"></span>
                <span class="ticket-loader__qr-scan"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ticket-loader__footer">
        <span class="ticket-loader__dot"></span>
        <div>
          <strong>No cierres esta página</strong>
          <small>Normalmente toma solo unos segundos.</small>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SpinnerSec',

  computed: {
    qrModules() {
      return [
        '1110011010',
        '1001010011',
        '1011110100',
        '0010111101',
        '1101001011',
        '1010011100',
        '0111010011',
        '1100101110',
      ].flatMap((row, rowIndex) => row.split('').flatMap((cell, colIndex) => {
        if (cell !== '1') {
          return []
        }

        return {
          key: `${rowIndex}-${colIndex}`,
          x: colIndex * 10,
          y: rowIndex * 10,
        }
      }))
    },
  },
}
</script>

<style scoped>
.ticket-loader {
  width: 100%;
  display: grid;
  justify-items: center;
}

.ticket-loader__shell {
  width: min(100%, 760px);
  display: grid;
  gap: 20px;
  padding: 24px;
  border-radius: 30px;
  background:
    radial-gradient(circle at top right, rgba(108, 92, 171, 0.08), transparent 24%),
    radial-gradient(circle at top left, rgba(214, 220, 236, 0.05), transparent 22%),
    linear-gradient(180deg, rgba(15, 17, 24, 0.985), rgba(7, 9, 14, 0.985));
  border: 1px solid rgba(194, 201, 219, 0.1);
  box-shadow: 0 26px 52px rgba(0, 0, 0, 0.24);
}

.ticket-loader__header h3,
.ticket-loader__ticket-copy strong,
.ticket-loader__footer strong {
  margin: 0;
  color: #f3f5fb;
}

.ticket-loader__eyebrow,
.ticket-loader__ticket-top span,
.ticket-loader__ticket-top small,
.ticket-loader__step strong {
  font-family: 'Space Grotesk', sans-serif;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.ticket-loader__eyebrow {
  display: inline-flex;
  margin-bottom: 10px;
  color: rgba(223, 228, 238, 0.82);
  font-size: 0.72rem;
  font-weight: 700;
}

.ticket-loader__header h3 {
  font-family: 'Syne', sans-serif;
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  line-height: 0.92;
  letter-spacing: -0.05em;
}

.ticket-loader__header p,
.ticket-loader__ticket-copy p,
.ticket-loader__step span,
.ticket-loader__footer small {
  margin: 10px 0 0;
  color: rgba(201, 208, 224, 0.82);
  line-height: 1.65;
}

.ticket-loader__stage {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
  align-items: stretch;
}

.ticket-loader__steps {
  display: grid;
  gap: 12px;
}

.ticket-loader__step {
  display: grid;
  gap: 6px;
  padding: 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(194, 201, 219, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.02);
}

.ticket-loader__step strong {
  color: rgba(180, 184, 198, 0.92);
  font-size: 0.72rem;
}

.ticket-loader__step.is-active {
  position: relative;
  background: linear-gradient(180deg, rgba(23, 25, 35, 0.92), rgba(16, 18, 26, 0.92));
  border-color: rgba(194, 201, 219, 0.12);
}

.ticket-loader__step.is-active::before {
  content: '';
  position: absolute;
  inset: 12px auto 12px 0;
  width: 3px;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(126, 111, 179, 0.9), rgba(80, 84, 109, 0.6));
}

.ticket-loader__step.is-active span {
  color: #eef2fb;
}

.ticket-loader__visual {
  position: relative;
  min-height: 260px;
}

.ticket-loader__ticket {
  border-radius: 28px;
  border: 1px solid rgba(194, 201, 219, 0.1);
  background:
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.08), transparent 26%),
    linear-gradient(180deg, rgba(22, 24, 36, 0.98), rgba(9, 11, 18, 0.98));
  box-shadow: 0 24px 46px rgba(0, 0, 0, 0.24);
}

.ticket-loader__ticket--back {
  position: absolute;
  top: 10px;
  right: 28px;
  width: min(100%, 320px);
  height: 190px;
  opacity: 0.28;
  transform: rotate(-4deg);
}

.ticket-loader__ticket--front {
  position: absolute;
  inset: auto 0 0 auto;
  width: min(100%, 380px);
  min-height: 220px;
  padding: 20px;
  transform: rotate(2deg);
  display: grid;
  gap: 18px;
}

.ticket-loader__ticket-top {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #d9deea;
  font-size: 0.72rem;
}

.ticket-loader__ticket-copy strong {
  display: block;
  font-size: 1.1rem;
}

.ticket-loader__ticket-copy p {
  margin-top: 8px;
}

.ticket-loader__qr-shell {
  position: relative;
  width: 126px;
  height: 126px;
  padding: 14px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.18);
}

.ticket-loader__qr-grid {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 14px;
  background: #ffffff;
}

.ticket-loader__qr-module {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 1px;
  background: #14161f;
}

.ticket-loader__qr-scan {
  position: absolute;
  left: 0;
  right: 0;
  top: 8px;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent, rgba(143, 148, 176, 0.96), transparent);
  box-shadow: 0 0 16px rgba(122, 111, 179, 0.26);
  animation: ticket-loader-scan 2.2s ease-in-out infinite;
}

.ticket-loader__footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(194, 201, 219, 0.08);
}

.ticket-loader__footer > div {
  display: grid;
  gap: 4px;
}

.ticket-loader__dot {
  width: 11px;
  height: 11px;
  flex: 0 0 11px;
  border-radius: 50%;
  background: #a6aac3;
  box-shadow: 0 0 0 8px rgba(166, 170, 195, 0.1), 0 0 18px rgba(121, 108, 177, 0.28);
  animation: ticket-loader-pulse 1.8s ease-in-out infinite;
}

@keyframes ticket-loader-scan {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  50% {
    transform: translateY(88px);
    opacity: 1;
  }
}

@keyframes ticket-loader-pulse {
  0%,
  100% {
    transform: scale(0.92);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.08);
    opacity: 1;
  }
}

@media (max-width: 720px) {
  .ticket-loader__shell {
    gap: 16px;
    padding: 18px 14px;
    border-radius: 24px;
  }

  .ticket-loader__header h3 {
    font-size: 2rem;
  }

  .ticket-loader__header p {
    font-size: 0.98rem;
  }

  .ticket-loader__stage {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .ticket-loader__visual {
    min-height: auto;
    display: grid;
  }

  .ticket-loader__ticket--back {
    display: none;
  }

  .ticket-loader__ticket--front {
    position: relative;
    inset: auto;
    width: 100%;
    min-height: auto;
    padding: 18px;
    transform: none;
    gap: 14px;
  }

  .ticket-loader__ticket-copy strong {
    font-size: 1rem;
  }

  .ticket-loader__ticket-copy p {
    font-size: 0.95rem;
    line-height: 1.55;
  }

  .ticket-loader__qr-shell {
    width: 112px;
    height: 112px;
  }

  .ticket-loader__footer {
    align-items: flex-start;
  }

  .ticket-loader__footer strong,
  .ticket-loader__footer small {
    display: block;
  }
}
</style>
